export const largeSourceImage = (sourceImageURL) => {
    return sourceImageURL.replace('/srcimg%2F', '/srcimg_large%2F')
}

const comparableArtworkURL = (url) => largeSourceImage(url).replace('/100x100', '/600x600');

export const episodeArtworkURL = (trackInfo) => {
    const imageURL = typeof trackInfo?.imageURL === 'string' ? trackInfo.imageURL.trim() : '';
    const showImageURL = typeof trackInfo?.source?.imageURL === 'string' ? trackInfo.source.imageURL.trim() : '';
    // Cached or imported episode metadata can repeat either size of the show cover.
    if (!imageURL || comparableArtworkURL(imageURL) === comparableArtworkURL(showImageURL)) {
        return null;
    }
    return imageURL;
};
